/*!
 * Copyright 2022 Thorne Health Lab. All rights reserved.
 */
/* eslint-disable @typescript-eslint/camelcase */
// eslint-disable-next-line lodash-fp/consistent-name, lodash-fp/use-fp
import { round } from 'lodash'
import PropTypes from 'prop-types'
import React, { Fragment } from 'react'
import DownCarot from '../../../assets/icons/carat.svg'
import List from '../../../components/List'
import DistChart from './ChartComponents/Distribution'

class Anthropometrics extends React.Component {
  constructor(props) {
    super(props)

    // getinitialState
    this.state = {
      height: this.HeightData(),
      weight: this.WeightData(),
      waistCirc: this.WaistCircData(),
      waistHip: this.WaistHipData(),
      absi: this.ABSIData(),
      sbsi: this.SBSIData(),
      trunk: this.TrunkData()
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.setState({
      height: this.HeightData(),
      weight: this.WeightData(),
      waistCirc: this.WaistCircData(),
      waistHip: this.WaistHipData(),
      absi: this.ABSIData(),
      sbsi: this.SBSIData(),
      trunk: this.TrunkData()
    })
  }

  humanizeFeet(height = 0) {
    const feet = Math.floor(height)
    const inch = (height - feet) * 12
    let humanized = ''

    if (inch > 0) {
      humanized = `${feet}' ${round(inch)}"`
    } else {
      humanized = `${feet}'`
    }
    return humanized
  }

  HeightData() {
    const { details } = this.props
    let stats = details.height

    return {
      display_label: stats.display_label,
      unit: stats.unit,
      value: stats.value,
      interpretation: stats.interpretation,
      percentile: stats.percentile,
      ranges: stats.ranges,
      test_name: stats.test_name,
      density_plot: stats.density_plot
    }
  }

  WeightData() {
    const { details } = this.props
    let stats = details.weight

    return {
      display_label: stats.display_label,
      unit: stats.unit,
      value: stats.value,
      interpretation: stats.interpretation,
      percentile: stats.percentile,
      ranges: stats.ranges,
      test_name: stats.test_name,
      density_plot: stats.density_plot
    }
  }

  WaistCircData() {
    const { details } = this.props
    let stats = details.waist_circumference

    return {
      display_label: stats.display_label,
      unit: stats.unit,
      value: stats.value,
      interpretation: stats.interpretation,
      percentile: stats.percentile,
      ranges: stats.ranges,
      test_name: stats.test_name,
      density_plot: stats.density_plot
    }
  }

  WaistHipData() {
    const { details } = this.props
    let stats = details.waist_to_hip_ratio

    return {
      display_label: stats.display_label,
      unit: stats.unit,
      value: stats.value,
      interpretation: stats.interpretation,
      percentile: stats.percentile,
      ranges: stats.ranges,
      test_name: stats.test_name,
      density_plot: stats.density_plot
    }
  }

  ABSIData() {
    const { details } = this.props
    let stats = details.absi

    return {
      display_label: stats.display_label,
      unit: stats.unit,
      value: stats.value,
      interpretation: stats.interpretation,
      percentile: stats.percentile,
      ranges: stats.ranges,
      test_name: stats.test_name,
      density_plot: stats.density_plot
    }
  }

  SBSIData() {
    const { details } = this.props
    let stats = details.sbsi

    return {
      display_label: stats.display_label,
      unit: stats.unit,
      value: stats.value,
      interpretation: stats.interpretation,
      percentile: stats.percentile,
      ranges: stats.ranges,
      test_name: stats.test_name,
      density_plot: stats.density_plot
    }
  }

  TrunkData() {
    const { details } = this.props
    let stats = details.trunk_to_leg_volume_ratio

    return {
      display_label: stats.display_label,
      unit: stats.unit,
      value: stats.value,
      interpretation: stats.interpretation,
      percentile: stats.percentile,
      ranges: stats.ranges,
      test_name: stats.test_name,
      density_plot: stats.density_plot
    }
  }

  render() {
    const { index, details, hotload } = this.props

    const items = {
      physicalActivity: {
        title: '<h2 class="mobile-padding">Anthropometrics</h2>',
        icon: { src: DownCarot },
        isShowAccordianOnMobile: true,
        accordianContent: `
      <div class="mobile-padding">
            <div>
              <p class="noMarginPadding">
                Anthropometrics is the measurement of a person’s body geometry
            (lengths, circumferences, areas, and volumes). Lab100 uses 3D body
            surface scanning to measure clinically-relevant anthropometrics.
              </p>
            </div>
            <br/>
          <div class="intro-title">
                International Physical Activity <br/> Questionnaire (IPAQ)
              </div>
              <br/>
          </div>`
      }
    }
    const listProps = {
      items,
      isMobile: this.props.isMobile,
      isNoTopBorder: true,
      isNotSpacer: true,
      isCollapsedDark: true,
      isReportStyle: true
    }

    return (
      <div className="anthropometrics-content module-content">
        <div className="intro-zone">
          {this.props.isMobile ? (
            <List {...listProps} />
          ) : (
            <p>
              Anthropometrics is the measurement of a person’s body geometry
              (lengths, circumferences, areas, and volumes). Lab100 uses 3D body
              surface scanning to measure clinically-relevant anthropometrics.
            </p>
          )}
        </div>
        {!this.props.isMobile && <hr className="anthro-divider" />}

        {hotload ? (
          <div className="mobile-padding">
            <strong className="subject anthro-title">
              Your Anthropometrics
            </strong>
            <div className="scan-bucket">
              <ul className="image-array">
                <li>
                  <img
                    src={details.images['000_deg']}
                    alt="zero degree angle"
                  />
                </li>
                <li>
                  <img
                    src={details.images['120_deg']}
                    alt="zero degree angle"
                  />
                </li>
                <li>
                  <img
                    src={details.images['270_deg']}
                    alt="zero degree angle"
                  />
                </li>
                <li>
                  <img
                    src={details.images['315_deg']}
                    alt="zero degree angle"
                  />
                </li>
              </ul>
            </div>
            {!this.props.isMobile && (
              <Fragment>
                {' '}
                <br />
                <br />
                <br />
              </Fragment>
            )}
            <div className="bucket">
              <div className="table">
                <div className="trow height">
                  <div className="td even-width">
                    <strong className="subject">
                      {details.height.display_label}
                    </strong>
                  </div>
                  <div className="td even-width">
                    <strong className="value">
                      {this.humanizeFeet(details.height.value)}
                    </strong>
                    <span className="descriptor">{details.height.unit}</span>
                  </div>
                  <div className="td even-width">
                    <strong className="value">
                      {details.height.percentile}%
                    </strong>
                    <span className="descriptor">Percentile</span>
                  </div>
                  <div className="td">
                    <DistChart
                      label={'Height'}
                      details={details}
                      index={index}
                      data={this.state.height}
                    />
                  </div>
                </div>
              </div>
              {!details.height.__ok ? (
                <div className="no-report-data">
                  {`No ${details.height.display_label} Data Available`}
                </div>
              ) : null}
            </div>
            <div className="bucket">
              <div className="table">
                <div className="trow weight">
                  <div className="td even-width">
                    <strong className="subject">
                      {details.weight.display_label}
                    </strong>
                  </div>
                  <div className="td even-width">
                    <strong className="value">{details.weight.value}</strong>
                    <span className="descriptor">{details.weight.unit}</span>
                  </div>
                  <div className="td even-width">
                    <strong className="value">
                      {details.weight.percentile}%
                    </strong>
                    <span className="descriptor">Percentile</span>
                  </div>
                  <div className="td">
                    <DistChart
                      label={'Weight'}
                      details={details}
                      index={index}
                      data={this.state.weight}
                    />
                  </div>
                </div>
              </div>
              {!details.weight.__ok ? (
                <div className="no-report-data">
                  {`No ${details.weight.display_label} Data Available`}
                </div>
              ) : null}
            </div>
            <div className="bucket">
              <div className="table">
                <div className="trow waist-circ">
                  <div className="td even-width">
                    <strong className="short-subject subject">
                      {details.waist_circumference.display_label}
                    </strong>
                  </div>
                  <div className="td even-width">
                    <strong className="value">
                      {details.waist_circumference.value}
                    </strong>
                    <span className="descriptor">
                      {details.waist_circumference.unit}
                    </span>
                  </div>
                  <div className="td even-width">
                    <strong className="value">
                      {details.waist_circumference.percentile}%
                    </strong>
                    <span className="descriptor">Percentile</span>
                  </div>
                  <div className="td">
                    <DistChart
                      label={'WaistCirc'}
                      details={details}
                      index={index}
                      data={this.state.waistCirc}
                    />
                  </div>
                </div>
              </div>

              <p>
                Waist circumference predicts risk of cardiovascular disease
                independently of body mass index (BMI) and body fat percentage.
              </p>
              {!details.waist_circumference.__ok ? (
                <div className="no-report-data">
                  {`No ${details.waist_circumference.display_label} Data Available`}
                </div>
              ) : null}
            </div>
            <div className="bucket">
              <div className="table">
                <div className="trow waist-hip">
                  <div className="td even-width">
                    <strong className="short-subject subject">
                      {details.waist_to_hip_ratio.display_label}
                    </strong>
                  </div>
                  <div className="td even-width">
                    <strong className="value">
                      {details.waist_to_hip_ratio.value}
                    </strong>
                    <span className="descriptor">
                      {details.waist_to_hip_ratio.unit}
                    </span>
                  </div>
                  <div className="td even-width">
                    <strong className="value">
                      {details.waist_to_hip_ratio.percentile}%
                    </strong>
                    <span className="descriptor">Percentile</span>
                  </div>
                  <div className="td">
                    <DistChart
                      label={'WaistHip'}
                      details={details}
                      index={index}
                      data={this.state.waistHip}
                    />
                  </div>
                </div>
              </div>

              <p>
                Waist to hip ratio is obtained from dividing waist circumference
                by hip circumference. It provides a rough indication of risk of
                obesity, coronary heart disease, and/or high blood pressure.
              </p>
              {!details.waist_to_hip_ratio.__ok ? (
                <div className="no-report-data">
                  {`No ${details.waist_to_hip_ratio.display_label} Data Available`}
                </div>
              ) : null}
            </div>
            {/* <div className="bucket">
              <div className="table">
                <div className="trow absi">
                  <div className="td even-width">
                    <strong className="subject">
                      {details.absi.display_label}
                    </strong>
                  </div>
                  <div className="td even-width">
                    <strong className="value">{details.absi.value}</strong>
                    <span className="descriptor">{details.absi.unit}</span>
                  </div>
                  <div className="td even-width">
                    <strong className="value">
                      {details.absi.percentile}%
                    </strong>
                    <span className="descriptor">Percentile</span>
                  </div>
                  <div className="td">
                    <DistChart
                      label={'ABSI'}
                      details={details}
                      index={index}
                      data={this.state.absi}
                    />
                  </div>
                </div>
              </div>

              <p>
                A Body Shape Index (ABSI) evaluates total body shape based on
                waist circumference, body mass index (BMI), and height. Higher
                scores predict health and disease-related risks associated with
                obesity.
              </p>
              {!details.absi.__ok ? (
                <div className="no-report-data">
                  {`No ${details.absi.display_label} Data Available`}
                </div>
              ) : null}
            </div> */}
            {/* <div className="bucket">
              <div className="table">
                <div className="trow sbsi">
                  <div className="td even-width">
                    <strong className="subject">
                      {details.sbsi.display_label}
                    </strong>
                  </div>
                  <div className="td even-width">
                    <strong className="value">{details.sbsi.value}</strong>
                    <span className="descriptor">{details.sbsi.unit}</span>
                  </div>
                  <div className="td even-width">
                    <strong className="value">
                      {details.sbsi.percentile}%
                    </strong>
                    <span className="descriptor">Percentile</span>
                  </div>
                  <div className="td">
                    <DistChart
                      label={'SBSI'}
                      details={details}
                      index={index}
                      data={this.state.sbsi}
                    />
                  </div>
                </div>
              </div>

              <p>
                Surface-based Body Shape Index (SBSI) evaluates total body shape
                by comparing the amount of mass in a person's torso to the
                amount of mass in the rest of the body. Higher scores predict
                health and disease-related risks associated with obesity.
              </p>
              {!details.sbsi.__ok ? (
                <div className="no-report-data">
                  {`No ${details.sbsi.display_label} Data Available`}
                </div>
              ) : null}
            </div> */}
            <div className="bucket">
              <div className="table">
                <div className="trow trunk">
                  <div className="td even-width">
                    <strong className="subject short-subject">
                      {details.trunk_to_leg_volume_ratio.display_label}
                    </strong>
                  </div>
                  <div className="td even-width">
                    <strong className="value">
                      {details.trunk_to_leg_volume_ratio.value}
                    </strong>
                    <span className="descriptor">
                      {details.trunk_to_leg_volume_ratio.unit}
                    </span>
                  </div>
                  <div className="td even-width">
                    <strong className="value">
                      {details.trunk_to_leg_volume_ratio.percentile}%
                    </strong>
                    <span className="descriptor">Percentile</span>
                  </div>
                  <div className="td">
                    <DistChart
                      label={'Trunk'}
                      details={details}
                      index={index}
                      data={this.state.trunk}
                    />
                  </div>
                </div>
              </div>

              <p>
                Trunk to Leg Volume Ratio compares the volume of a person’s
                trunk to the volume of the legs. A high ratio of trunk to leg
                volume may be associated with prediabetes, diabetes, high
                triglyceride counts, high blood pressure, metabolic syndrome,
                and other health complications.
              </p>
              {!details.trunk_to_leg_volume_ratio.__ok ? (
                <div className="no-report-data">
                  {`No ${details.trunk_to_leg_volume_ratio.display_label} Data Available`}
                </div>
              ) : null}
            </div>
          </div>
        ) : null}
      </div>
    )
  }
}

Anthropometrics.propTypes = {
  details: PropTypes.object.isRequired
}

export default Anthropometrics
